module.exports = {"131182100":"唐奉镇","131182101":"深州镇","131182102":"辰时镇","131182103":"榆科镇","131182104":"魏家桥镇","131182105":"大堤镇","131182106":"前磨头镇","131182107":"王家井镇","131182108":"护驾迟镇","131182109":"大屯镇","131182110":"高古庄镇","131182200":"兵曹乡","131182201":"穆村乡","131182202":"东安庄乡","131182203":"北溪村乡","131182204":"大冯营乡","131182206":"乔屯乡","131182400":"河北省深州监狱","131182401":"深州市城市新区管理委员会","131182403":"经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131182.json
// module id = 256
// module chunks = 0